import { useEffect } from "react";
import { useRouteError } from "react-router";
import { useTranslation } from "@/shared/i18n/LocaleProvider";
import { HeaderButton } from "@/shared/ui/StepHeaderControls";

export function RouteErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();

  useEffect(() => {
    console.error("[simon] route error caught by RouteErrorPage:", error);
  }, [error]);

  return (
    <div className="flex min-h-0 flex-1 items-center justify-center overflow-auto bg-[var(--color-bg)] p-[24px]">
      <div
        role="alert"
        className="flex w-full max-w-[560px] flex-col gap-[12px] rounded-[var(--radius-md)] border border-[var(--color-border)] bg-[var(--color-paper)] px-[20px] py-[18px]"
      >
        <p className="font-(family-name:--font-display) text-md text-[var(--color-text-strong)]">
          {t("crash.page.heading")}
        </p>
        <div className="mt-[4px] flex">
          <HeaderButton primary onClick={() => window.location.reload()}>
            {t("crash.page.reload")}
          </HeaderButton>
        </div>
      </div>
    </div>
  );
}
